import { Component, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { SessionService } from '@app/core/services/client-services/session-service/session.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { LoginResponse } from 'api/models';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

interface SidebarSegment {
    label: string;
    destination: string;
}

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-user-settings',
    templateUrl: './user-settings.component.html',
    styleUrls: ['./user-settings.component.scss'],
    imports: [
        MatIcon,
        RouterLink,
        RouterLinkActive,
        MatButton,
        MatTooltip,
        RouterOutlet,
        TranslateModule,
    ],
})
export class UserSettingsComponent {
    private router = inject(Router);

    userSession: LoginResponse;

    constructor() {
        this.userSession = inject(SessionService).getSession();
    }

    sidebarSegments: SidebarSegment[] = [
        {
            label: 'SETTINGS.PROFILE-SETTINGS',
            destination: '/settings',
        },
        {
            label: 'SETTINGS.CHANGE-MAIL',
            destination: '/settings/email',
        },
        {
            label: 'SETTINGS.CHANGE-PW',
            destination: '/settings/password',
        },
    ];

    closeSettings() {
        this.router.navigate(['/']);
    }
}
